/** Vuoto = richieste relative → proxy dev (package.json) verso staging, evita CORS/HSTS. */
export const API_URL =
  process.env.REACT_APP_API_URL !== undefined
    ? process.env.REACT_APP_API_URL
    : "https://8kxvr9zj6j.execute-api.eu-west-1.amazonaws.com";

/** Pagina iniziale dopo login/registrazione o visita senza path. */
export const DEFAULT_HOME_PATH = "/libreria-esercizi";

/** Base URL per PDF schede (vuoto in .env = proxy verso staging; in prod: cdn.corpore.fit). */
export const PDF_CDN_URL =
  process.env.REACT_APP_PDF_CDN_URL !== undefined
    ? process.env.REACT_APP_PDF_CDN_URL
    : "https://cdn.corpore.fit";

/** Base URL per poster e video esercizi (default CDN; vuoto in .env = proxy dev). */
export const EXERCISES_MEDIA_URL =
  process.env.REACT_APP_EXERCISES_MEDIA_URL !== undefined
    ? process.env.REACT_APP_EXERCISES_MEDIA_URL
    : PDF_CDN_URL;

/** Base URL app mobile per link scheda (deep link). */
export const APP_LINK_BASE =
  process.env.REACT_APP_APP_LINK_BASE || "https://app.corpore.fit";

/** Base URL sito Corpore per tabella prezzi riattiva (Stripe checkout con customer-secret). */
export const TABELLA_PREZZI_RIATTIVA_BASE =
  process.env.REACT_APP_TABELLA_PREZZI_RIATTIVA_BASE || "https://corpore.fit";

export const PRIVACY_POLICY_URL = `${TABELLA_PREZZI_RIATTIVA_BASE}/privacy-policy/`;

export const TERMS_URL = `${TABELLA_PREZZI_RIATTIVA_BASE}/termini-e-condizioni/`;

export const STRIPE_PUBLISHABLE_KEY =
  process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY || "";

export const STRIPE_MODE = process.env.REACT_APP_STRIPE_MODE || "test";

/** Ripetizione appuntamenti in modale (disabilitata finché la serie non è completa). */
export const APPOINTMENT_RECURRENCE_ENABLED =
  process.env.REACT_APP_APPOINTMENT_RECURRENCE === "true";

/** Sincronizzazione Google Calendar — attiva solo se REACT_APP_GOOGLE_CALENDAR_SYNC=true (staging: sì, production: no finché non c’è approvazione Google). */
export const GOOGLE_CALENDAR_SYNC_ENABLED =
  process.env.REACT_APP_GOOGLE_CALENDAR_SYNC === "true";

/** localStorage: visibilità per calendario personale in agenda (JSON id → boolean). */
export const PERSONAL_CALENDAR_VISIBILITY_STORAGE_KEY =
  "corpore-personal-calendar-visibility";

/** Toggle sede attiva/non attiva in lista e form indirizzi (disabilitato finché non è pronta). */
export const ADDRESS_ACTIVE_TOGGLE_ENABLED =
  process.env.REACT_APP_ADDRESS_ACTIVE_TOGGLE === "true";
